module.exports = __webpack_public_path__ + "media/images/client-7-f457df1c05b4544ea7f5ad12194644bb.png";